
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/spotlight/styles.css";
import "./theme/global.css";

import App from "./App";
import { useAuthStore } from "./stores/authStore";
import { applyChrome, useUiStore } from "./stores/uiStore";

// Paint the persisted palette/density onto <html> before the first render so the
// app never flashes the default theme.
{
  const { palette, density } = useUiStore.getState();
  applyChrome(palette, density);
}

// Start listening to Firebase auth state before the first render. Wrapped
// because the /dev mount must still boot with no Firebase config present.
try {
  useAuthStore.getState().init();
} catch {
  // No Firebase config — only /dev is usable, which is fine.
}

// NOTE: deliberately not wrapped in React.StrictMode. React 19's StrictMode
// remounts effects (mount → cleanup → mount) in development, which cancels the
// enter transition inside Mantine's ModalBase: Drawers and Modals mount, start
// animating, then unmount and never come back. Production builds are unaffected
// either way, and every overlay in this console goes through ModalBase.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
